import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { I18nService } from '../../services/i18n.service';

/** Strips legacy /en and /ar prefix URLs (old host) and always lands on Arabic. */
@Component({
  selector: 'app-legacy-locale-redirect',
  template: '',
})
export class LegacyLocaleRedirectComponent implements OnInit {
  constructor(
    private readonly router: Router,
    private readonly i18n: I18nService
  ) {}

  ngOnInit(): void {
    this.i18n.setLanguage('ar');

    const match = this.router.url.match(/^\/(?:en|ar)(?:\/(.*))?$/);
    const rest = match?.[1] ? `/${match[1]}` : '/';
    void this.router.navigateByUrl(rest, { replaceUrl: true });
  }
}
